var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46824 7.33355L11.8083 1.9934C11.9319 1.86989 12 1.70501 12 1.5292C12 1.3534 11.9319 1.18852 11.8083 1.06501L11.4151 0.671749C11.1589 0.415848 10.7425 0.415848 10.4867 0.671748L6.00249 5.15601L1.51326 0.666772C1.38965 0.543261 1.22487 0.475067 1.04916 0.475067C0.873261 0.475067 0.708483 0.543261 0.584776 0.666772L0.191707 1.06004C0.068098 1.18365 9.15499e-07 1.34843 9.07814e-07 1.52423C9.00129e-07 1.70003 0.068098 1.86491 0.191707 1.98842L5.53664 7.33355C5.66064 7.45735 5.8262 7.52535 6.0022 7.52496C6.17888 7.52535 6.34434 7.45735 6.46824 7.33355Z",
    fill: "#7828A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.13a41ed5b87946219e08a817cfb4bb73.svg";
export { ForwardRef as ReactComponent };